export default {"src":"/_next/static/media/filter.8011ea8c.svg","height":18,"width":18};